import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { iconsLibrary } from '../../../../theme/constants';
import { EActiveTab } from '../../../data-types/tabs.enum';

@Component({
  selector: "cowing-tabs",
  templateUrl: "./cowing-tabs.component.html",
  styleUrls: ["./cowing-tabs.component.scss"],
})
export class CowingTabsComponent {
  public EActiveTab = EActiveTab;

  @Input("active") public activeTab: EActiveTab = EActiveTab.Explore;

  constructor(private router: Router) {}

  public get getExploreIcon() {
    return `${iconsLibrary.explore}`;
  }
  public get getExploreIconActive() {
    return `${iconsLibrary.exploreActive}`;
  }

  public get getFavIcon() {
    return `${iconsLibrary.fav}`;
  }
  public get getFavIconActive() {
    return `${iconsLibrary.favActive}`;
  }

  public get getBriefcaseIcon() {
    return `${iconsLibrary.briefcase}`;
  }
  public get getBriefcaseIconActive() {
    return `${iconsLibrary.briefcaseActive}`;
  }

  public get getBookingIcon() {
    return `${iconsLibrary.booking}`;
  }
  public get getBookingIconActive() {
    return `${iconsLibrary.bookingActive}`;
  }

  public get getProfileIcon() {
    return `${iconsLibrary.profile}`;
  }
  public get getProfileIconActive() {
    return `${iconsLibrary.profileActive}`;
  }

  public async goToNavigation(path: string, active: EActiveTab) {
    await this.router.navigate([path]);
    this.activeTab = active;
  }

  public setActive(active: EActiveTab) {
    switch (active) {
      case EActiveTab.Booking:
        return this.goToNavigation('coworker-booking', active);
      case EActiveTab.Office:
        return this.goToNavigation('coworker-office', active);
      case EActiveTab.Explore:
        return this.goToNavigation('coworker-explore', active);
      case EActiveTab.Profile:
        return this.goToNavigation('coworker-profile', active);
    }
  }
}
